window.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll("div[role='tab']");
  var container = document.getElementById('container');
  var buttons_support = document.querySelectorAll('[data-video]');
  var support_overlays = document.querySelectorAll('.operating-system');
  var createDiv = function createDiv(id) {
    var div = document.createElement('div');
    div.classList.add(id.dataset.system);
    id.append(div);
    div.setAttribute('data-elfsight-app-lazy', '');
  };
  var displaySelectedVideos = function displaySelectedVideos(system) {
    support_overlays.forEach(function (section) {
      var video = section.querySelector("[data-system=\"".concat(system, "\"]")).dataset.video;
      var div = document.createElement('div');
      div.classList.add(video);
      section.parentElement.append(div);
      section.classList.add('hidden');
    });
  };
  buttons_support.forEach(function (platform) {
    platform.addEventListener('click', function () {
      var system = platform.dataset.system;
      displaySelectedVideos(system);
    });
  });
  document.getElementById('backToTop').addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  });
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      // Find the corresponding tabpanel
      var product = tab.getAttribute('aria-controls');
      var panel = document.getElementById(product);
console.log(product, panel);

      var loaded_videos = panel.querySelectorAll('[class^=elfsight-app-]');
console.log(product, panel, loaded_videos);
      //Load videos
      if (loaded_videos.length === 0) {
        var video_ids = panel.querySelectorAll('[data-system]');
        video_ids.forEach(function (id) {
          return createDiv(id);
        });
      }

      // Change aria-hidden
      container.querySelector('[aria-hidden="false"]').setAttribute('aria-hidden', true);
      panel.setAttribute('aria-hidden', false);

      // Scroll to top of the steps
      window.scrollTo({
        top: container.offsetTop,
        behavior: 'smooth'
      });
    });
  });
});